import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { UserIcon } from '../../../../common/icons';
import CommonSubHeader from '../../SubHeader';
import UploadFile from './UploadFile';

import './SubHeader.css';

@inject('translationsStore', 'commonStore', 'authStore')
@observer
export default class SubHeader extends Component {
  constructor(props) {
    super(props);
    this.NewGroupModalRef = React.createRef();
  }

  render() {
    const { translationsStore, commonStore, authStore } = this.props;

    let profileData = commonStore.dealer;

    if (authStore.isServiceManager) {
      profileData = commonStore.profile;
    }
    return (
      <CommonSubHeader className="ProfileSubHeader">
        <div className="leftContainer">
          {(!authStore.isServiceManager) && (
          <UploadFile
            className="icon-profile"
            image={
              <UserIcon
                style={{
                  color: 'var(--primary-color)',
                  position: 'relative',
                  zIndex: '30'
                }}
                width="28"
                height="28"
              />
            }
            label={translationsStore.translate('profile.changeProfileText')}
            labelClassName="changeProfileText"
          />
          )}

          <div className="usernameHeader">{(profileData || {}).companyName}</div>
        </div>

        <div className="rightContainer" />
      </CommonSubHeader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Profile/SubHeader/SubHeader.js